(function () {
  'use strict';

  const REFERENCES = [["Protein*","g",55,70],["Arginin*","g",1.3,1.84],["Histidin","g",0.58,0.63],["Isoleucin","g",1.15,1.25],["Leucin","g",2.05,2],["Lysin*","g",1.05,1.75],["Methionin*","g",1,0.65],["Methionin + Cystin*","g",1.91,1.33],["Phenylalanin","g",1.35,1.25],["Phenylalanin + Tyrosin*","g",2.23,2.5],["Threonin","g",1.3,1.6],["Tryptophan","g",0.43,0.53],["Valin","g",1.48,1.4],["Fett*","g",25,30],["Linolsäure (ω-6)*","g",3,3],["Arachidonsäure (ω-6)*","mg",null,75],["Alpha-Linolensäure (ω-3)*","g",0.5,0.5],["EPA + DHA (ω-3)*","g",0.3,0.4],["Calcium*","g",1.2,3],["Phosphor*","g",1,2.5],["Kalium","g",1.25,1.1],["Natrium*","g",0.2,0.3],["Chlorid","g",0.38,0.83],["Magnesium","g",0.05,0.1],["Kupfer*","mg",2,3],["Jod*","mg",0.3,0.3],["Eisen*","mg",9,22],["Mangan","mg",1.44,1.4],["Selen* (Nassfutter)","µg",57.5,100],["Selen* (Trockenfutter)","µg",45,100],["Zink*","mg",20,30],["Vitamin A*","IU",2000,3000],["Vitamin D*","IU",200,300],["Vitamin E*","IU",20,30],["Vitamin B1 (Thiamin)*","mg",0.54,0.45],["Vitamin B2 (Riboflavin)*","mg",1.5,1.05],["Vitamin B5 (Pantothensäure)*","mg",3.55,3],["Vitamin B6 (Pyridoxin)*","mg",0.36,0.3],["Vitamin B12 (Cobalamin)*","µg",8.36,7],["Vitamin B3 (Niacin)*","mg",4.09,3.4],["Vitamin B9 (Folsäure)*","µg",64.5,54],["Biotin (Vitamin B7)*","µg",null,null],["Cholin","mg",500,500],["Vitamin K*","µg",null,null]];

  const PRODUCTS = [{"name":"Lamm Adult","phase":"Adult","me":355,"nutrients":[23.4,1.6383,0.6047,0.9682,1.7742,1.6838,0.3881,0.6534,1.0893,1.7916,null,null,1.2246,8.55,null,null,null,null,1.4,1.05,0.79,0.3,0.43,0.1,1.1,0.37,8,0.8,16,16,16,2150,215,42.6,0.84,1.26,null,0.84,6,21.55515,null,37.19,null,null]},{"name":"Lamm baby","phase":"Puppy","me":345,"nutrients":[29.7,1.9974,0.754,1.2167,2.2285,2.09,0.4836,0.8234,1.3639,2.2788,null,null,1.5127,9,null,null,null,null,1.5,1.05,0.7175,0.1,0.4763,0.15,0.9,0.32,6.8,0.68,14,14,13.5,2000,200,40,1.8,2.3,null,1.9,19,24.05911,null,40.29,null,null]},{"name":"Huhn light","phase":"Adult","me":354.3,"nutrients":[18,1.2512,0.4215,0.752,1.3948,1.24,0.4629,0.6505,0.807,1.6167,null,null,0.961,9,null,null,null,null,1.2,0.9,0.7879,0.3,0.5507,0.13,1.33857,0.36909,21.394,1.19481,30.37,30.37,13.56146,2000,200,40,1,1.5,null,1.6,11,13.18919,null,29.57,null,null]},{"name":"Huhn Adult","phase":"Adult","me":362.5,"nutrients":[23.85,1.5871,0.5337,0.9265,1.7051,1.6223,0.4779,0.692,0.9921,1.8587,null,null,1.1802,8.325,null,null,null,null,1.35,1,0.6525,0.35,0.5189,0.12,1.1,0.37,8,0.8,16,16,16,2150,215,42.6,0.84,1.26,null,0.84,6,13.17536,null,30.18,null,null]},{"name":"Huhn aktiv","phase":"Adult","me":385,"nutrients":[23.58,1.7396,0.5727,0.9813,1.8112,1.6383,0.4827,0.7259,1.0642,1.9566,null,null,1.2393,14.4,null,null,null,null,1.35,0.95,0.6509,0.35,0.4387,0.12,0.9,0.32,6.8,0.68,10,10,13.5,1850,180,25,0.89,1.44,null,1.27,11,11.58609,null,426.71,null,null]},{"name":"Huhn small","phase":"Adult","me":393,"nutrients":[24.3,1.7942,0.5901,1.0063,1.8714,1.691,0.5057,0.7543,1.0837,2.0195,null,null,1.2785,15.3,null,null,null,null,1.25,1,0.6401,0.4,0.4665,0.1081,1.52834,0.39679,22.22063,1.4854,40.18,40.18,14.83839,1800,180,40,0.91717,1.45027,null,1.23337,13.14,11.67842,null,431.71,null,null]},{"name":"Huhn big","phase":"Adult","me":378.2,"nutrients":[22.5,1.6314,0.5439,0.9345,1.7212,1.558,0.4492,0.6796,1.0056,1.8682,null,null,1.1813,14.4,null,null,null,null,1.35,1.05,0.6715,0.1,0.5458,0.15,1.55324,0.38238,20.63112,1.5482,36.81,36.81,14.45589,1800,180,25,1.03966,1.45471,null,1.27274,11.84,11.98183,null,28.65,null,null]},{"name":"Lachs Adult","phase":"Adult","me":360,"nutrients":[23.4,1.651,0.6705,1.0708,1.6566,1.8196,0.4855,0.7277,0.983,1.9176,null,null,1.255,8.55,null,null,null,null,1.4,0.95,1.0038,0.35,0.7004,0.12,1.1,0.37,8,0.8,16,16,16,2150,215,42.6,0.84,1.26,null,0.84,6,20.46125,null,40.19,null,null]},{"name":"Kaninchen Adult","phase":"Adult","me":340,"nutrients":[23.58,1.7272,0.5642,1.0143,1.7832,1.7392,0.3768,0.7226,1.0601,1.9293,null,null,1.2291,8.1,null,null,null,null,1.35,1,0.7875,0.3,0.506,0.16,1.1,0.37,8,0.8,16,16,16,2150,215,42.6,0.84,1.26,null,0.84,6,19.82149,null,38.96,null,null]},{"name":"Kaninchen small","phase":"Adult","me":415,"nutrients":[26.1,1.4777,0.458,1.0195,1.9429,1.8509,0.4906,0.836,1.0603,2.0986,null,null,1.3366,19.8,null,null,null,null,1.25,1.1,0.6719,0.27,0.6627,0.16,0.9,0.32,6.8,0.68,10,10,13.5,2000,200,42.5,1.2,1.4,null,1.55,7,10.6709,null,492.53,null,null]}];

  const NUTRIENT_INDEX = Object.fromEntries(REFERENCES.map((reference, index) => [reference[0], index]));

  function lifecycle(ageMonths) {
    if (ageMonths < 3.5) return 'Puppy_early';
    if (ageMonths < 12) return 'Puppy_late';
    if (ageMonths >= 84) return 'Senior';
    return 'Adult';
  }

  function merFactor(activity, goal) {
    if (goal === 'abnehmen') return 0.8;
    if (goal === 'zunehmen') return 1.8;
    return { niedrig: 1.2, normal: 1.4, hoch: 1.8 }[activity] || 1.4;
  }

  function matches(product, phase, weight) {
    const puppy = phase.startsWith('Puppy');
    const phaseMatch = puppy ? ['Puppy', 'All'].includes(product.phase) : ['Adult', 'Senior', 'All'].includes(product.phase);
    if (puppy) return phaseMatch;
    const lowerName = product.name.toLowerCase();
    const sizeMatch = weight <= 10
      ? lowerName.includes('small')
      : weight >= 25
        ? lowerName.includes('big')
        : !lowerName.includes('small') && !lowerName.includes('big');
    return phaseMatch && sizeMatch;
  }

  function targetFor(reference, phase) {
    return phase.startsWith('Puppy') ? reference[3] : reference[2];
  }

  function intakePer1000(product, nutrientIndex) {
    const value = product.nutrients[nutrientIndex];
    return value == null ? null : value / product.me * 1000;
  }

  function calculate(input) {
    const phase = lifecycle(input.age);
    const rer = 70 * Math.pow(input.weight, 0.75);
    const mer = rer * merFactor(input.activity, input.goal);
    const ranked = PRODUCTS.filter((product) => matches(product, phase, input.weight)).map((product) => {
      let score = 0;
      let deficits = 0;
      REFERENCES.forEach((reference, index) => {
        const target = targetFor(reference, phase);
        const intake = intakePer1000(product, index);
        if (target == null || intake == null || target === 0) return;
        const deficit = Math.max(0, (target - intake) / target);
        score += deficit;
        if (deficit > 0) deficits += 1;
      });
      return { ...product, score, deficits, grams: mer / product.me * 100 };
    }).sort((a, b) => a.score - b.score);
    return { phase, rer, mer, ranked, best: ranked[0] || null };
  }

  function doseLabel(value, type) {
    if (!Number.isFinite(value)) return '';
    if (type === 'oil' && value < 0.05) return '0';
    const rounded = Math.round((value + Number.EPSILON) * 10) / 10;
    return rounded.toFixed(1).replace('.', ',');
  }

  function supplementRecommendations(result) {
    if (!result.best) return [];
    const product = result.best;
    const deficitDay = (name) => {
      const index = NUTRIENT_INDEX[name];
      const target = targetFor(REFERENCES[index], result.phase);
      const intake = intakePer1000(product, index);
      if (target == null) return 0;
      return Math.max(0, (target - (intake == null ? 0 : intake)) * result.mer / 1000);
    };

    const phaseComplex = result.phase.startsWith('Puppy')
      ? { name: 'Vitamin Optimix Cani Puppy & Junior', contents: { 'Calcium*': 23, 'Phosphor*': 10, 'Magnesium': 0.8, 'Natrium*': 4, 'Kupfer*': 0.35, 'Zink*': 3, 'Jod*': 0.034, 'Vitamin A*': 220, 'Vitamin D*': 25 } }
      : result.phase === 'Senior'
        ? { name: 'Vitamin Optimix Cani Senior 375g', contents: { 'Calcium*': 180, 'Phosphor*': 50, 'Magnesium': 29, 'Natrium*': 9, 'Kupfer*': 0.35, 'Zink*': 4, 'Jod*': 0.05, 'Vitamin A*': 250, 'Vitamin D*': 30 } }
        : { name: 'Vitamin Optimix Cani Cooking', contents: { 'Calcium*': 19, 'Phosphor*': 5, 'Magnesium': 29, 'Natrium*': 1, 'Kupfer*': 0.35, 'Zink*': 2.5, 'Jod*': 0.05, 'Vitamin A*': 250, 'Vitamin D*': 30 } };

    const unitToMg = new Set(['Calcium*', 'Phosphor*', 'Magnesium', 'Natrium*']);
    const complexDose = Math.max(0, ...Object.entries(phaseComplex.contents).map(([name, perGram]) => {
      const deficit = deficitDay(name);
      return unitToMg.has(name) ? deficit * 1000 / perGram : deficit / perGram;
    }));

    const grouped = new Map();
    const add = (name, dose, giving, type = 'powder') => {
      if (!(dose > 0)) return;
      const current = grouped.get(name);
      if (!current || dose > current.dose) grouped.set(name, { name, dose, giving, type });
    };

    if (complexDose > 0) add(phaseComplex.name, complexDose, 'g täglich');
    add('Calciumcarbonat', deficitDay('Calcium*') * 1000 / 380, 'g täglich');
    add('Optisolo Magnesium', deficitDay('Magnesium') * 1000 / 310, 'g täglich');
    add('Optisolo Kupfer', deficitDay('Kupfer*') / 0.6, 'g täglich');
    add('Optisolo Zink', deficitDay('Zink*') / 15, 'g täglich');
    add('Seealgenmehl', deficitDay('Jod*') / 0.5, 'g täglich');
    add('Dorschlebertran', Math.max(deficitDay('Vitamin A*') / 1600, deficitDay('Vitamin D*') / 168), 'g täglich', 'oil');

    const bDoses = [
      ['Vitamin B1 (Thiamin)*', 3.5, 1], ['Vitamin B2 (Riboflavin)*', 3.5, 1],
      ['Vitamin B6 (Pyridoxin)*', 3, 1], ['Vitamin B12 (Cobalamin)*', 40, 1],
      ['Vitamin B3 (Niacin)*', 30, 1], ['Vitamin B9 (Folsäure)*', 0.4, 1000],
      ['Biotin (Vitamin B7)*', 125, 1]
    ].map(([name, perGram, conversion]) => deficitDay(name) / (perGram * conversion));
    add('Optisolo B-Komplex', Math.max(...bDoses), 'g täglich');
    add('Optinature Fellglanz Barf Öl', deficitDay('Alpha-Linolensäure (ω-3)*') * 1000 / 164, 'g pro Gabe, 3× pro Woche', 'oil');
    return Array.from(grouped.values()).map((item) => ({ ...item, displayDose: doseLabel(item.dose, item.type), unitNote: item.type === 'oil' ? '1 g = 1 ml = ¼ TL' : '1 Messbecher (liegt bei) = 0,4 g' }));
  }

  function parseStoreProducts(root) {
    const node = root.querySelector('[data-pf-products]');
    if (!node) return {};
    try { return JSON.parse(node.textContent); } catch (_) { return {}; }
  }

  function render(root, result, storeProducts, storeSupplements) {
    const output = root.querySelector('[data-pf-output]');
    if (!result.best) {
      root.querySelector('[data-pf-error]').textContent = 'Für diese Kombination wurde noch kein passendes Trockenfutter hinterlegt.';
      return;
    }
    root.querySelector('[data-pf-error]').textContent = '';
    const best = result.best;
    const storeProduct = storeProducts[best.name] || {};
    const min = Math.round(best.grams * 0.88);
    const max = Math.round(best.grams);
    root.querySelector('[data-pf-range]').textContent = `${min}–${max} g`;
    root.querySelector('[data-pf-product-title]').textContent = storeProduct.title || best.name;
    const productLink = root.querySelector('[data-pf-product-link]');
    productLink.href = storeProduct.url || '#';
    const image = root.querySelector('[data-pf-product-image]');
    if (storeProduct.image) { image.src = storeProduct.image; image.alt = storeProduct.title || best.name; image.hidden = false; } else { image.hidden = true; }

    const select = root.querySelector('[data-pf-variant]');
    select.innerHTML = '';
    const variants = (storeProduct.variants || []).filter((variant) => variant.available !== false && !/100\s*g.*probier/i.test(variant.title));
    variants.forEach((variant) => {
      const option = document.createElement('option');
      option.value = variant.id;
      option.textContent = `${variant.title} – ${variant.price}`;
      select.appendChild(option);
    });
    root.querySelector('[data-pf-cart-area]').hidden = variants.length === 0;

    const alternatives = root.querySelector('[data-pf-alternatives]');
    alternatives.innerHTML = '';
    result.ranked.slice(1, 3).forEach((item) => {
      const meta = storeProducts[item.name] || {};
      const li = document.createElement('li');
      li.className = 'pf-calculator__alternative';
      const itemMin = Math.round(item.grams * 0.88);
      const itemMax = Math.round(item.grams);
      const link = document.createElement('a');
      link.className = 'pf-calculator__alternative-product';
      link.href = meta.url || '#';
      if (meta.image) {
        const alternativeImage = document.createElement('img');
        alternativeImage.src = meta.image;
        alternativeImage.alt = '';
        alternativeImage.width = 72;
        alternativeImage.height = 72;
        alternativeImage.loading = 'lazy';
        link.appendChild(alternativeImage);
      } else {
        link.classList.add('pf-calculator__alternative-product--no-image');
      }
      const title = document.createElement('span');
      title.textContent = meta.title || item.name;
      link.appendChild(title);
      const amount = document.createElement('span');
      amount.className = 'pf-calculator__alternative-amount';
      amount.textContent = `${itemMin}–${itemMax} g/Tag`;
      li.append(link, amount);
      const availableVariants = (meta.variants || []).filter((variant) => variant.available !== false && !/100\s*g.*probier/i.test(variant.title));
      if (availableVariants.length) {
        const controls = document.createElement('div');
        controls.className = 'pf-calculator__alternative-controls';
        const variantSelect = document.createElement('select');
        variantSelect.setAttribute('aria-label', 'Packungsgröße für ' + (meta.title || item.name));
        variantSelect.dataset.pfAlternativeVariant = '';
        availableVariants.forEach((variant) => {
          const option = document.createElement('option');
          option.value = variant.id;
          option.textContent = variant.title + ' – ' + variant.price;
          variantSelect.appendChild(option);
        });
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pf-calculator__supplement-add';
        button.dataset.pfAlternativeAdd = '';
        button.textContent = 'In den Warenkorb';
        button.setAttribute('aria-label', (meta.title || item.name) + ' in den Warenkorb');
        controls.append(variantSelect, button);
        li.appendChild(controls);
      }
      alternatives.appendChild(li);
    });
    root.querySelector('[data-pf-alternative-section]').hidden = alternatives.children.length === 0;

    const supplementList = root.querySelector('[data-pf-supplements]');
    supplementList.innerHTML = '';
    const supplements = supplementRecommendations(result);
    supplements.forEach((supplement) => {
      const li = document.createElement('li');
      li.className = 'pf-calculator__supplement';
      li.innerHTML = `<strong>${supplement.name}</strong><span class="pf-calculator__supplement-amount">${supplement.displayDose} ${supplement.giving}</span><small class="pf-calculator__supplement-note">${supplement.unitNote}</small>`;
      const item = storeSupplements[supplement.name];
      if (item && item.available && item.variantId) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pf-calculator__supplement-add';
        button.textContent = 'In den Warenkorb';
        button.dataset.variantId = item.variantId;
        button.setAttribute('aria-label', `${item.title} in den Warenkorb`);
        li.appendChild(button);
      }
      supplementList.appendChild(li);
    });
    root.querySelector('[data-pf-supplement-section]').hidden = supplements.length === 0;
    const media = root.querySelector('[data-pf-media]');
    if (media) media.hidden = true;
    output.hidden = false;
    output.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  async function addToCart(button, variantId, quantity) {
    if (!variantId || button.disabled) return;
    button.disabled = true;
    button.textContent = 'Wird hinzugefügt …';
    try {
      const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(rootPath + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity }], sections: ['cart-drawer', 'cart-icon-bubble', 'mobile-cart-icon-bubble'], sections_url: window.location.pathname })
      });
      if (!response.ok) throw new Error('cart');
      const added = await response.json();
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && added.sections && added.sections['cart-drawer']) {
        cartDrawer.classList.remove('is-empty');
        cartDrawer.setActiveElement(button);
        cartDrawer.renderContents(added);
      }
      try {
        const cartResponse = await fetch(rootPath + 'cart.js', { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          const total = new Intl.NumberFormat(document.documentElement.lang || 'de-AT', {
            style: 'currency', currency: cart.currency || 'EUR'
          }).format(cart.total_price / 100);
          document.querySelectorAll('[data-cart-toatal]').forEach((node) => { node.textContent = total; });
          const cartIcon = document.querySelector('#cart-icon-bubble');
          if (cartIcon) {
            let countBubble = cartIcon.querySelector('.cart-count-bubble');
            if (cart.item_count > 0) {
              if (!countBubble) {
                countBubble = document.createElement('div');
                countBubble.className = 'cart-count-bubble';
                const count = document.createElement('span');
                count.setAttribute('aria-hidden', 'true');
                const description = document.createElement('span');
                description.className = 'visually-hidden';
                countBubble.append(count, description);
                const price = cartIcon.querySelector('.main-cart-price');
                if (price) price.before(countBubble); else cartIcon.appendChild(countBubble);
              }
              countBubble.querySelector('[aria-hidden="true"]').textContent = cart.item_count;
              countBubble.querySelector('.visually-hidden').textContent = cart.item_count === 1 ? '1 Artikel' : cart.item_count + ' Artikel';
            } else if (countBubble) {
              countBubble.remove();
            }
          }
        }
      } catch (_) { /* The item was added; the header will refresh on the next page load. */ }
      button.textContent = 'Hinzugefügt ✓';
    } catch (_) {
      button.textContent = 'Bitte erneut versuchen';
    } finally {
      button.disabled = false;
    }
  }

  function init(root) {
    if (root.dataset.pfReady === 'true') return;
    root.dataset.pfReady = 'true';
    const form = root.querySelector('[data-pf-form]');
    const storeProducts = parseStoreProducts(root);
    let storeSupplements = {};
    try { storeSupplements = JSON.parse(root.querySelector('[data-pf-supplement-products]').textContent); } catch (_) { storeSupplements = {}; }
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = new FormData(form);
      const input = {
        weight: Number(data.get('weight')),
        age: Number(data.get('age')),
        activity: String(data.get('activity')),
        goal: String(data.get('goal'))
      };
      if (!(input.weight > 0 && input.weight <= 100) || !(input.age >= 0.5 && input.age <= 300)) {
        root.querySelector('[data-pf-error]').textContent = 'Bitte gib ein gültiges Gewicht und Alter ein.';
        return;
      }
      render(root, calculate(input), storeProducts, storeSupplements);
    });

    root.addEventListener('click', (event) => {
      const supplementButton = event.target.closest('[data-pf-supplements] [data-variant-id]');
      if (supplementButton && root.contains(supplementButton)) {
        addToCart(supplementButton, supplementButton.dataset.variantId, 1);
        return;
      }
      const alternativeButton = event.target.closest('[data-pf-alternative-add]');
      if (alternativeButton && root.contains(alternativeButton)) {
        const variantId = alternativeButton.closest('li').querySelector('[data-pf-alternative-variant]').value;
        addToCart(alternativeButton, variantId, 1);
      }
    });

    root.querySelector('[data-pf-add]').addEventListener('click', () => {
      const button = root.querySelector('[data-pf-add]');
      const variantId = root.querySelector('[data-pf-variant]').value;
      const quantity = Math.max(1, Number(root.querySelector('[data-pf-quantity]').value) || 1);
      addToCart(button, variantId, quantity);
    });
  }

  function initAll() { document.querySelectorAll('[data-pf-calculator]').forEach(init); }
  if (typeof document !== 'undefined') {
    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { lifecycle, merFactor, calculate, supplementRecommendations, REFERENCES, PRODUCTS };
}());
